import { render, staticRenderFns } from "./Acordion.vue?vue&type=template&id=7c176c46&scoped=true&lang=pug&"
import script from "./Acordion.vue?vue&type=script&lang=js&"
export * from "./Acordion.vue?vue&type=script&lang=js&"
import style0 from "./Acordion.vue?vue&type=style&index=0&id=7c176c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c176c46",
  null
  
)

export default component.exports